import React from "react";
import ContentAdminQuestaoTextEditor from "./ContentAdminQuestaoTextEditor";

const AdminQuestaoRegistroTextEditor = () => {
  return (
    <>
      <ContentAdminQuestaoTextEditor />
    </>
  );
};

export default AdminQuestaoRegistroTextEditor;
